class DebugHelper {
  public static isDebug(): boolean {
    return typeof localStorage !== 'undefined' && localStorage.getItem('debug')?.toString() === 'true';
  }
}

export default DebugHelper;
